import transform from "lodash/transform";
import PropTypes from "prop-types";
import React, { useCallback } from "react";

const passRefs = (selectors, reactNode, callback, selectAll) => {
  const refs = transform(
    selectors,
    (result, selector, name) => {
      result[name] =
        selectAll === true
          ? reactNode.querySelectorAll(selector)
          : reactNode.querySelector(selector);
    },
    {},
  );

  callback(refs);
};

const InnerNodes = ({ callback, children, selectAll, selectors }) => {
  const nodeRef = useCallback(
    (node) => {
      if (node === null) {
        callback(null);
      } else {
        passRefs(selectors, node, callback, selectAll);
      }
    },
    // We need to memoize this to prevent
    // infinite callbacks when this component gets re-rendered
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [callback, children, selectors, selectAll],
  );

  return <div ref={nodeRef}>{children}</div>;
};

InnerNodes.proptypes = {
  callback: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  selectAll: PropTypes.bool,
  selectors: PropTypes.object.isRequired,
};

export default InnerNodes;
